export interface RuntimeState {
  getRuntimeState: () => StateParameters;
  setParameters: (params?: Partial<StateParameters>) => void;
}

interface StateParameters {
  [key: string]: unknown;
  isStorageInitialized?: boolean;
}

let runtimeState = null;

export const createRuntimeState = (): RuntimeState => {
  if (runtimeState) {
    return runtimeState;
  }

  let currentState: StateParameters = {};

  const setParameters = (configParams: Partial<StateParameters>) => {
    currentState = { ...currentState, ...configParams };
  };

  const getRuntimeState = () => currentState;

  runtimeState = {
    setParameters,
    getRuntimeState,
  };

  return runtimeState;
};

export const resetRuntimeState = () => {
  runtimeState = null;
};
